import React from "react";
import { Input } from "reactstrap";
import { digitsOnly, formatPhoneDisplay } from "../utility/formatPhoneDisplay";

const PhoneInput = ({ name = "phone", value = "", onChange, ...rest }) => {
    const handleChange = (evt) => {
        const raw = digitsOnly(evt.target.value);
        if (typeof onChange === "function") onChange(raw); // pass digits up
    };

    return (
        <Input
            {...rest}
            name={name}
            type="tel"
            value={formatPhoneDisplay(value)} // show masked
            onChange={handleChange}
            placeholder="(507) 999-1234"
        />
    );
};

export default PhoneInput;
